import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RemoteRecord } from '@client/common/redux/RemoteRecord';
import { AppState } from '@client/common/redux/store';
import { fetchRmaInvoice, selectRmaInvoice } from '@client/myAccount/rma/redux/rma/redux';
import { RmaInvoiceType } from 'b2b-common/core/account/api/rma';

export const useRmaInvoiceEffect = (rmaInvoiceId: string, debitorId?: string): RemoteRecord<RmaInvoiceType> => {
  const dispatch = useDispatch();
  const rmaInvoice = useSelector((state: AppState) => selectRmaInvoice(state, rmaInvoiceId));

  useEffect(() => {
    rmaInvoiceId && dispatch(fetchRmaInvoice({ rmaInvoiceId, debitorId }));
  },
  [rmaInvoiceId]);

  return rmaInvoice;
};
